export default __webpack_public_path__ + "static/media/keyicon.bb795792.svg";